
import { defineComponent, onMounted, provide, ref } from 'vue'
import { useRoute } from 'vue-router';

//import service
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-tournament-manager",
    setup() {
        const route = useRoute();
        const { id } = route.params
        const evento = ref<any>({})
        //provide("evento", evento)

        const getDetails = async () => {
            await pservice.getDetails(`${id}?type=slug&list=false`)
                .then((res) => {
                    evento.value = res.data
                }).catch(({ response }) => { })
        }

        onMounted(() => {
            getDetails()
        })

        return {
            id,
            evento,
            getDetails
        }

    },
})
